module.exports = __webpack_public_path__ + "static/media/Q3_Back_Right.1acf5642.png";